import '@crewlixSrc/assets/css/main.css'
import '@crewlixSrc/assets/icon/the-icon-of.css'

import { createApp } from 'vue'
import App from '@crewlixSrc/App.vue'
import { pinia } from '@crewlixSrc/store'
import router from '@crewlixSrc/router'

const app = createApp(App)

app.use(pinia)
app.use(router)

app.mount('#app')
